import React, { useEffect, useState } from "react";
import ButtonSkaRound from "../Buttons/ButtonSkaRound";
import strings from "../../helpers/Localization";
const CardCallLog = ({ resource, isClientShare }) => {
    const [exists, setExists] = useState(true);

    const isImage
        = resource && resource.url && /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(resource.url);
    const isImageFormatNotSupportedForThumb
        = resource && resource.url && /\.(heic|heif|dng|avif)$/i.test(resource.url);
    const isVideo
        = resource && (
            resource.type === "PilotSharescreenClientRecorder"
            || resource.type === "intercomRecorder"
        );
    const isPDF
        = resource && resource.url && /\.(pdf)$/i.test(resource.url);

    useEffect(() => {
        if (!resource || !resource.url) {
            setExists(false);
            return;
        }

        if (isImage) {
            const img = new Image();
            img.src = resource.url;
            img.onload = () => setExists(true);
            img.onerror = () => setExists(false);
        }
        else {
            /*fetch(resource.url, { method: "HEAD" })
                .then((res) => setExists(res.ok))
                .catch(() => setExists(false));*/
        }
    }, [isImage, resource]);

    const getResourceTitle = () => {
        if (resource.type === "intercomRecorder") {return strings.RecordingByAgent;}
        if (resource.type === "PilotSharescreenClientRecorder") {return strings.RecordingByAgent;}
        if (resource.type === "screenshotIntercom") {return strings.ScreenshotByAgent;}
        if (resource.type === "screenshotPilotSharescreenClient") {return strings.ScreenshotByAgent;}
        if (isClientShare) {return strings.SendedByClient;}
        return strings.SendedByAgent;
    };

    if (!exists) {
        return (
            <div className="cardResourceContainer" style={{ height: "210px" }}>
                <div
                    className="cardResourceImage"
                    style={{
                        background:
                            "url(images/thumbDefault/thumb-default-file.png) lightgray 50% / cover no-repeat"
                    }}
                />
                <div className="cardResourceBottom">
                    La pièce jointe a été supprimée
                </div>
            </div>
        );
    }

    return (
        <div className="cardResourceContainer" style={{ height: "210px" }}>
            <div
                className="cardResourceImage"
                style={
                    isImage
                        ? { background: `url(${resource.url}) lightgray 50% / cover no-repeat` }
                        : isImageFormatNotSupportedForThumb
                            ? {
                                background:
                                  "url(images/thumbDefault/thumb-default-file-image.png) lightgray 50% / cover no-repeat"
                            }
                            : isVideo
                                ? {
                                    background:
                                  "url(images/thumbDefault/thumb-default-video-recording.png) lightgray 50% / cover no-repeat"
                                }
                                : isPDF
                                    ? {
                                        background:
                                  "url(images/thumbDefault/thumb-default-file-pdf.png) lightgray 50% / cover no-repeat"
                                    }
                                    : {
                                        background:
                                  "url(images/thumbDefault/thumb-default-file.png) lightgray 50% / cover no-repeat"
                                    }
                }
            />
            <div className="cardResourceBottom">
                <div
                    style={{
                        display: "flex",
                        flexGrow: "1",
                        flexDirection: "column",
                        gap: "5px",
                        maxWidth: "80%"
                    }}
                >
                    <span
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            fontWeight: "700"
                        }}
                    >
                        {getResourceTitle()}
                    </span>
                    <span
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            color: "var(--grey-base)"
                        }}
                    >
                        {resource.name}
                    </span>
                </div>
                <span style={{ display: "flex" }} />
                <div style={{ display: "flex" }}>
                    <ButtonSkaRound
                        type="primary"
                        onClick={() =>
                            window.open(resource.url, "_blank", "rel=noopener noreferrer")
                        }
                        nameIcon={isClientShare && isVideo ? "play" : "maximize"}
                    />
                </div>
                <span style={{ display: "flex" }} />
            </div>
        </div>
    );
};

export default CardCallLog;
